import {
  SimpleGrid,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React from "react";
import { FixAndFlipQuote } from "../../lib/models/short-term/short-term.model";

export type FixAndFlipTierTableProps = {
  constructionTable: boolean;
  quote: FixAndFlipQuote;
};

function FixAndFlipTierTable({
  constructionTable,
  quote,
}: FixAndFlipTierTableProps) {
  const { borrowerInfo } = quote;
  return (
    <>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Borrower Tier</Th>
            {constructionTable ? (
              <Th isNumeric>Completed Number of Builds*</Th>
            ) : (
              <Th isNumeric>Completed Number of Flips*</Th>
            )}
          </Tr>
        </Thead>
        <Tbody>
          {!constructionTable && (
            <>
              <Tr>
                <Td>Tier 1</Td>
                <Td isNumeric>0</Td>
              </Tr>
              <Tr>
                <Td>Tier 2</Td>
                <Td isNumeric>1-4</Td>
              </Tr>
            </>
          )}
          <Tr>
            <Td>Tier 3</Td>
            <Td isNumeric>5-11</Td>
          </Tr>
          <Tr>
            <Td>Tier 4</Td>
            <Td isNumeric>12-23</Td>
          </Tr>
          <Tr>
            <Td>Tier 5</Td>
            <Td isNumeric>Over 24</Td>
          </Tr>
        </Tbody>
      </Table>
      <Text textAlign="right" fontSize="xs" marginTop={4}>
        *Completed in the last 36 months
      </Text>

      <SimpleGrid marginTop={6} marginLeft={8} columns={2}>
        {borrowerInfo?.buildsCompletedInThreeYears &&
        borrowerInfo?.buildsCompletedInThreeYears > 0 &&
        constructionTable ? (
          <div>
            <dt>{`${"Builds Completed > 3 Years:"}`}</dt>
            <dd>{borrowerInfo?.buildsCompletedInThreeYears}</dd>
          </div>
        ) : null}
        {borrowerInfo?.completedExits && borrowerInfo.completedExits > 0 ? (
          <div>
            <dt>Completed Exits:</dt>
            <dd>{borrowerInfo?.completedExits}</dd>
          </div>
        ) : null}

        {borrowerInfo?.fnfCompletedInThreeYears &&
        borrowerInfo?.fnfCompletedInThreeYears > 0 ? (
          <div>
            <dt>{`${"Flips Completed > 3 Years:"}`}</dt>
            <dd>{borrowerInfo?.fnfCompletedInThreeYears}</dd>
          </div>
        ) : null}
      </SimpleGrid>
    </>
  );
}
export default FixAndFlipTierTable;
